exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-positions[data-v-61b9e0fc] {\n  max-width: 683px;\n}\n.top-positions .top-positions__ol[data-v-61b9e0fc] {\n  padding: 0 16px;\n  list-style-type: decimal;\n}", ""]);

// exports
